export const WEBHOOK_REGEX = /^https:\/\/(.+?)\/v1\/alerts\/webhook\//;
